import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AppButton, AppCard, WhatsAppButton } from '@/components/atoms';

const steps = [
  'Our team checks the cars you selected and confirms they are still available.',
  'We prepare a quotation with the price, shipping and the estimated taxes.',
  'We contact you on the WhatsApp number you gave us.',
];

export function SubmittedDetails({ reference }: { reference: string }) {
  return (
    <AppCard sx={{ p: { xs: 6, md: 10 } }}>
      <Stack spacing={5} alignItems="flex-start">
        <Stack spacing={1}>
          <Typography variant="overline" color="text.secondary">
            Your reference
          </Typography>
          <Typography variant="h3" component="p" className="tabular-nums">
            {reference}
          </Typography>
        </Stack>

        <Stack spacing={2}>
          <Typography variant="h6" component="h2">
            What happens next
          </Typography>
          <Stack component="ol" spacing={2} sx={{ m: 0, pl: 5 }}>
            {steps.map((step) => (
              <Typography component="li" key={step} color="text.secondary">
                {step}
              </Typography>
            ))}
          </Stack>
        </Stack>

        <Typography variant="body2" color="text.secondary">
          This request is not a purchase, a reservation or a deposit, and no payment has been taken.
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
          <WhatsAppButton
            message={`Hello Kabex Motors, I submitted quotation request ${reference}.`}
          >
            Continue on WhatsApp
          </WhatsAppButton>
          <AppButton to="/cars" appVariant="secondary">
            Browse more cars
          </AppButton>
        </Stack>
      </Stack>
    </AppCard>
  );
}
